/* This example requires Tailwind CSS v2.0+ */
import {XCircleIcon} from '@heroicons/react/20/solid'

export default function LoginError({errorMessage}) {
    return (
        <div className="rounded-md bg-red-50 p-4 mb-2">
            <div className="flex">
                <div className="flex-shrink-0">
                    <XCircleIcon className="h-5 w-5 text-red-700" aria-hidden="true"/>
                </div>
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">{errorMessage}</h3>
                </div>
            </div>
        </div>
    )
}
